export const HitsType = Object.freeze({
  newAndNoteworthyApps: 'newAndNoteworthyApps',
  recommendedApps: 'recommendedApps'
});